<nav aria-label="breadcrumb">
  <ol class="breadcrumb mb-0 p-0">
    <li class="breadcrumb-item" *ngFor="let breadcrumb of breadcrumbs; let last = last;" aria-current="page">
      <a class="d-flex align-items-center" [class.ds-active-link]="last" [routerLink]="breadcrumb.url">
        {{ breadcrumb.label }}
      </a>
    </li>
  </ol>
</nav>
